import { PropertyHelper } from '@/helpers/property.helper';
import { Utils } from '@/helpers/utils';
import { AlertService } from '@/services/alert.service';
import { formatDate, NgFor, NgIf } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { PropertiesService, PropertyPerson, RealProperty } from '@eemo/api-client';

import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { InputTrimDirective } from '../../extensions/inputTrimDirective';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

export class PropertyPeopleDialogData {
  prop: RealProperty;
  person?: PropertyPerson;
  edition = false;
}

@Component({
    selector: 'app-property-people-dialog',
    templateUrl: './property-people-dialog.component.html',
    styleUrls: ['./property-people-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, NgFor, MatOptionModule, NgIf, MatInputModule, InputTrimDirective, MatDatepickerModule, MatButtonModule]
})
export class PropertyPeopleDialogComponent implements OnInit {
  isBrowserSupportsDateInput = Utils.isBrowserSupportsDateInput;

  personForm: UntypedFormGroup;
  dialogTitle: string;
  formSubmitting = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PropertyPeopleDialogData,
    private propertyService: PropertiesService,
    private alertService: AlertService,
    private fb: UntypedFormBuilder,
    public propertyHelper: PropertyHelper,
    public dialogRef: MatDialogRef<PropertyPeopleDialogComponent>,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.dialogTitle = this.data.edition ? "Modifier l'occupant" : 'Ajouter un occupant';
  }

  // convenience getter for easy access to form fields
  f(field: string): AbstractControl {
    return this.personForm.get(field);
  }

  ngOnInit() {
    this.personForm = this.fb.group({
      type: [null, Validators.required],
      gender: [null, Validators.required],
      name: [null, [Validators.required, Validators.maxLength(50)]],
      firstName: [null, [Validators.required, Validators.maxLength(50)]],
      birthDate: [null, Validators.required],
      birthPlace: [null]
    });

    if (this.data.person) {
      this.personForm.patchValue(this.data.person);
    }
  }

  onSubmit() {
    if (this.personForm.valid) {
      this.formSubmitting = true;
      // parse the date to format date send by mat datepicker (browser with support of input type="date" doesn't need it)
      const birthDate = new Date(this.f('birthDate').value);
      this.f('birthDate').setValue(formatDate(birthDate, 'yyyy-MM-dd', this.locale));
      if (this.data.edition) {
        this.propertyService
          .updateRealPropertyPerson(this.data.prop.uid, this.data.person.uid, this.personForm.value)
          .subscribe(
            (result) => {
              this.dialogRef.close(true);
              this.alertService.success('Mise à jour effectuée');
            },
            (err: HttpErrorResponse) => {
              this.dialogRef.close();
            }
          );
      } else {
        this.propertyService.addRealPropertyPerson(this.data.prop.uid, this.personForm.value).subscribe(
          (createdId) => {
            this.dialogRef.close(createdId);
            this.alertService.success('Création effectuée');
          },
          (err: HttpErrorResponse) => {
            this.dialogRef.close();
          }
        );
      }
    }
  }
  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
